import { i18n } from '@lt/localization';
import { pluralizeFlights } from 'src/utils/pluralizeUtils';
import { LOADING_STATE } from '../../store/flights/constants';

export const humanizeCitiesArray = (citiesArr?: string[]): string =>
  citiesArr ? citiesArr.join(` ${i18n.t('checkout.filter.or')} `) : '';

export const getAirportsName = (count: number) =>
  count === 1
    ? i18n.t('checkout.packageInfo.transfer.airport')
    : i18n.t('checkout.filter.airports');

export const getButtonText = (count, fetching) => {
  if (fetching === LOADING_STATE.IS_LOADING) {
    return `${i18n.t('checkout.loading')}...`;
  }
  return `${
    count
      ? `${i18n.t('checkout.filter.show')} ${count}`
      : i18n.t('checkout.flight.luggage.textNo')
  } ${pluralizeFlights(count)}`;
};
